import dictionary from "./dictionary.mjs";

export default function translate(language, category, key) {
  return dictionary[language][category][key];
}

